import { gql } from '@/__generated__';

const DEVICES_ANALYSIS_GET_DEVICES_AVAILABLE_FIELDS = gql(`#graphql
  query DevicesAnalysis_GetDevicesAvailableFields($input: DevicesInput) {
    devices(input: $input) {
      id
      metrics {
        id
        availableFields
        flow {
          unit
        }
        level {
          unit
        }
      }
    }
  }
`);

export default DEVICES_ANALYSIS_GET_DEVICES_AVAILABLE_FIELDS;
